import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Capacitor } from '@capacitor/core';
import { getSubscribeStoreUrls } from '../../subscription/subscribeLinks';
import proPill from '../../assets/pro_pill.svg';

// "More" menu behind the profile header's ⋮ button (Figma 791:19905)
export default function ProfileMoreModal({ open, onClose, onOpenClubs, onSignOut }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const run = (action) => () => {
    onClose();
    action?.();
  };

  // Subscriptions aren't wired into the app yet, so the row links to the store listing for this platform
  const { ios, android } = getSubscribeStoreUrls();
  const proUrl = Capacitor.getPlatform?.() === 'android' ? android : ios;

  return createPortal(
    <div className="modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="modal profile-menu"
        role="dialog"
        aria-modal="true"
        aria-labelledby="profile-menu-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="profile-menu__header">
          <span className="event-page__icon-btn" aria-hidden="true" />
          <h3 id="profile-menu-title" className="profile-menu__title">More</h3>
          <button type="button" className="event-page__icon-btn" onClick={onClose} aria-label="Close">
            <span className="material-symbols-rounded" aria-hidden="true">close</span>
          </button>
        </div>

        <div className="profile-menu__list">
          <button type="button" className="profile-menu__row" onClick={run(onOpenClubs)}>
            <span className="profile-menu__icon material-symbols-rounded" aria-hidden="true">groups</span>
            <span>My clubs</span>
          </button>

          <a className="profile-menu__row" href={proUrl} target="_blank" rel="noopener noreferrer" onClick={onClose}>
            <span className="profile-menu__icon" aria-hidden="true">
              <img src={proPill} alt="" width="40" height="18.2191" />
            </span>
            <span>Upgrade to Padel Pro</span>
          </a>

          <button type="button" className="profile-menu__row" onClick={run(onSignOut)}>
            <span className="profile-menu__icon material-symbols-rounded" aria-hidden="true">logout</span>
            <span>Sign out</span>
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
